import { Divider, Grid, Table, TableBody, TableContainer, TableHead ,CircularProgress} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdAddBox } from "react-icons/md";
import { CiCircleQuestion } from "react-icons/ci";
import { toast } from "react-toastify";
import { DarkGreenColorButton, GreenColorButton, PrimeGrayBorderColorButton, StatusStyle } from "../../../Components/MaterialButtonStyle/StyleButton";
import { StyledTableCell, StyledTableRow } from "../../../Components/MaterialTableStyle/MaterialTableStyle";
import CustomCheckBox from "../../../Components/CheckBox/CustomCheckBox";
import TextAreaField from "../../../Components/CustomInputs/TextArea";
import RightSideModal from "../../../Components/Modal/RightSideModal";
import { OnlyDateTimeConverter } from "../../../Components/Helpers/DateTimeConverter";
import CustomInput from "../../../Components/CustomInputs/CustomInputs";
import FileUploadButton from "../../../Components/MaterialButtonStyle/UploadButton";
import CustomDropDown from "../../../Components/DropDown/CustomDropDown";
import { RejectionsInfo } from "../../Settings/DataFile/Data";
import CustomModal from "../../../Components/Modal/CustomModal";
import CerificateModal from "./CerificateModal";
import { GetPublicURL, PostMethod } from "../../../Helper/api";
const VerifyCertificateDetailsModal = ({ certificateVerifyModal, setCertificateVerifyModal, CloseVerfiyCertificateModal,Selectedtests, remarks, setRemarks, roleCheckBoxData, HandleChandidateChange, attachmentList, attachmentLoader,HandleAttachmentValueChange, HandleNewAttachment, applicationDetail, rejectReason, setRejectReason, UpdateVerifyCerticate, isEdit,CandidateDetail }) => {

  const [confomationModal, setConfomationModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [certificateImageModal, setCertificateImageModal] = useState(false);
  const [certificateName, setCertificateName] = useState("");
  const [selectedIndex, setSelectedIndex] = useState("");
  const [Certificates, setCertificates] = useState([]);
  const [QualificationCertificates, setQualificationCertificates] = useState([]);
  const [certificateSelectList, setCertificateSelectList] = useState({ "Yes": null, "No": null });
  const userid = JSON.parse(localStorage.getItem("@users"));
  const userType = localStorage.getItem("@userType");
  const [ExaminedPlace, setExaminedPlace] = useState();
  const [Loading, setLoading] = useState(false);
  const [attachmentNewList,setattachmentNewList] = useState([])
  const [Examinedby,setExaminedby] = useState("")
  const [Examinedon,setExaminedon] = useState("")
  const [fileExtentions,setfileExtentions] = useState("")
  const [applicant_image,setapplicant_image] = useState()

  const UpdateModalVerifyCerticate = () => {
    try {
      Certificates.map((row) => {
        if (!row?.No && !row.Yes) {
          throw new Error(`Please Select Status for ${row.name}`);
        }
      });
      QualificationCertificates.map((row) => {
        if (!row?.verified && !row.unVerified) {
          throw new Error(`Please Select  ${row.selectQualification} Qualification Status`);
        }
      });
      attachmentList.map((row, i) => {
        if (row?.attachmentName) {
          if (row?.attachmentName?.trim().length === 0) {
            throw new Error(`Please Enter Attachment Name - ${i + 1}`);
          }
          if (!row.fileUrl) {
            throw new Error(`Please Upload Attachment File in  - ${row.attachmentName}`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (!roleCheckBoxData.candidateFit && !roleCheckBoxData.candidateNotFit) {
      toast.error("Please Select Candidate Fitness");
      return
    }
    if (roleCheckBoxData.candidateNotFit) {
      if (!rejectReason) {
        toast.error("Please Select Reject Reason");
        return
      }
    }
    if (rejectReason == "Other (Specify)") {
      if (!remarks) {
        toast.error("Please Enter Remarks");
        return
      }
    }
    if (!remarks) {
      toast.error("Please Enter Remarks");
      return
    }
    if (remarks?.trim()?.length == 0) {
      toast.error("Please Enter Valid Remarks");
      return
    }
    setConfomationModal(true);
    setCertificateVerifyModal(false)
  }
  const UpdatePhysicalData = async() => {
    let userids =localStorage.getItem("@userid");

    if(!userids){
      toast.error("Something went wrong please try again");
      return
    }
    if(!Selectedtests?.physical_test_id){
      toast.error("Something went wrong please try again");
      return
    }

    try{
      let url="application/updatephysical"
      let method="PUT"
      let params={
        "physical_test_id":Selectedtests?.physical_test_id ,
        "test_name":"Certification Verification",
        "status":roleCheckBoxData.candidateNotFit? "rejected":"verified",
        "created_by":userids,
        "location":ExaminedPlace,
        "test_data":[{"name":"Certificates",values:Certificates},{"name":"QualificationCertificates",values:QualificationCertificates}],
        "remarks":remarks,
        "deficiencies":"",
        "attachment":attachmentList,
        usesType:userType
      }
      setLoading(true)
      const response = await PostMethod({url,method,params})
      if(response.status){
        setLoading(false)
        setConfomationModal(false);
        UpdateVerifyCerticate()
      }else{
        setLoading(false)
        if(response.message){
          toast.error(response.message)
        }else{
          toast.error("Something went wrong ")
        }
      }
    }catch(Error){
      UpdateVerifyCerticate()
      toast.error("Something went wrong ")
      console.log("Error",Error)
    }
   
  }
  const CloseConfomationModal = () => {
    setConfomationModal(false);
    setCertificateVerifyModal(true);
  }
  const OpenCerticateImage = async(row, i) => {

    setCertificateVerifyModal(false)
    setCertificateImageModal(true)
    let URL  =await GetPublicURL(row.certificateAttachmentURL)
    setfileExtentions(String(row.certificateAttachmentURL).split(".").pop())
    setImageUrl(URL);
    setCertificateName(row.selectQualification)
    setSelectedIndex(i);
    setCertificateSelectList({ "Yes": row?.verified, "No": row.unVerified })
  }
  const OpenCerticateImage1 = async(row, i) => {
    setCertificateVerifyModal(false)
    setCertificateImageModal(true)
    let URL  =await GetPublicURL(row.fileUrl)
    setfileExtentions(String(row.fileUrl).split(".").pop())
    setImageUrl(URL);
    setCertificateName(row.attachmentName)
    setSelectedIndex(i);
    setCertificateSelectList({ "Yes": row?.verified, "No": row.unVerified })
  }
  const CloseCerticateImage = () => {
    setCertificateVerifyModal(true)
    setCertificateImageModal(false)
    setImageUrl("");
    setCertificateName("")
    setSelectedIndex("")
  }
  const UpdateCerficate = (value, index, field) => {
    HandleCertificateChange(value, index, field)
    CloseCerticateImage()
  }
  const HandleCertificateChange = (value, index, field) => {
    const datasss= [...QualificationCertificates]
    if(field === "verified"){
      datasss[index].verified =true
      datasss[index].unVerified =false
    }else{
      datasss[index].verified =false
      datasss[index].unVerified =true
    }
    setQualificationCertificates(datasss)
   
  }
  const HandleCertificateVerificationChange = (value, index, field) => {
 
    const datas =[...Certificates]
    if(field === "Yes"){
      if(value== true){
        datas[index].Yes = true
        datas[index].No = false 
      }else{
        datas[index].Yes = false
        datas[index].No = false 
      }
    }else{
      if(value== true){
        datas[index].Yes = false
        datas[index].No = true 
      }else{
        datas[index].Yes = false
        datas[index].No = false 
      }
    }

    setCertificates(datas);
  }
  const GetpublicURLSS=async()=>{
    const response =await GetPublicURL(applicationDetail.applicant_image)
    setapplicant_image(response)
  }
  useEffect(()=>{
    if(Selectedtests?.physical_test_current_status=="pending"){
      if(applicationDetail?.physical_locations){
        if(applicationDetail.physical_locations[0]){
          setExaminedPlace(applicationDetail.physical_locations[0].value)
        }
      }
      if(applicationDetail?.applicant_image){
        GetpublicURLSS()
      }
      let namess = userid.first_name +" "+userid.last_name
      setExaminedby(namess)
      setExaminedon(Date.now())
      if(applicationDetail?.education_qualification){
        let array =[]
        let array1 =[]
        applicationDetail?.education_qualification?.map((row)=>{
          array1.push({
            selectQualification:row.selectQualification,certificateNumber:row.certificateNumber,certificateAttachmentURL:row.certificateAttachmentURL
          })
          row.table?.map((item)=>{
            array.push({
              name :`Candidate Having Required Credit in ${item?.subject} In ${row?.institutionName} Mentioned in Application Form? (${item.Credit})`,
              yes :false,
              No:false
            })
          })
        })
        setQualificationCertificates(array1)
        setCertificates(array)
      }
    }else{
      if(Selectedtests?.physical_test_current_status=="verified"){
        HandleChandidateChange(true, "candidateFit")
      }else if(Selectedtests?.physical_test_current_status=="rejected"){
        HandleChandidateChange(false, "candidateFit")
      }
      if(Selectedtests?.physical_test_data){
        setCertificates(Selectedtests.physical_test_data[0].values)
        setQualificationCertificates(Selectedtests.physical_test_data[1].values)
      }
      if(Selectedtests?.physical_test_examined_at){
        setExaminedon(Selectedtests.physical_test_examined_at)
        let name = Selectedtests.agent_first_name +" "+ Selectedtests.agent_last_name
        setExaminedby(name)
        setExaminedPlace(Selectedtests.physical_test_examined_location)
      }
      if(Selectedtests?.physical_test_attachment){
        setattachmentNewList(Selectedtests.physical_test_attachment)
        setRemarks(Selectedtests.physical_test_remarks)
      }
    }


  },[applicationDetail,CandidateDetail,Selectedtests])

  return (
    <Grid item >
      <RightSideModal
        open={certificateVerifyModal}
        setOpen={CloseVerfiyCertificateModal}
        width={"40%"}
        scroll={true}
        height={"90vh"}

        modalTitle={<h4 className="poppinsSemiBold Text-Prime-Black text-left">
          Verify Certificate Details
        </h4>}
        modalContent={
          <Grid item lg={12} md={12} sm={12} xs={12} className="p-2">
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"center"} justifyContent={"space-between"}>
              <Grid item lg={9} sm={9} md={9} xs={9} container alignItems={"center"}>
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name of the Post Applying for
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_name ? applicationDetail?.job_name : "--"}
                      {/* {applicationDetail.job_post} */}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Notification Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.notificationNumer ? applicationDetail?.notificationNumer : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Application Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.Title ? CandidateDetail?.Title+". " : ""}{CandidateDetail.Surname ? CandidateDetail.Surname : "--"}
                      {CandidateDetail.LastName ? " "+CandidateDetail.LastName : ""}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2} sm={2} md={2} xs={2} container justifyContent={"flex-end"}>
                {applicant_image&& <img src={applicant_image} alt="PSCLogo" height={150} width={150} className="img_fluid" />}
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Certificate Verification
                </h5>
                <Grid item className="w-20 mx-2">
                  <p className={StatusStyle(Selectedtests?.physical_test_current_status)}>{Selectedtests?.physical_test_current_status}</p>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} >
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableBody className="w-100">
                      {Certificates?.map((item,i)=>(
                        <StyledTableRow key={i}>
                          <StyledTableCell align="left">
                            <p className="poppinsRegular Text-Prime-Black">{item.name}</p>
                          </StyledTableCell>
                          {isEdit &&
                            < StyledTableCell align="center">
                              <Grid item container flexDirection={"row"} alignItems={"center"}>
                                <CustomCheckBox
                                  className={"p-0"}  disableColor={"transparent"} checked={item?.Yes}
                                  onChange={() => HandleCertificateVerificationChange(!item?.Yes, i, "Yes")}
                                />
                                <p className="poppinsRegular Text-Prime-Black text-center"> Yes </p>
                              </Grid>
                            </StyledTableCell>}
                          <StyledTableCell align="center">
                            {isEdit ?
                              <Grid item container flexDirection={"row"} alignItems={"center"} justifyContent={"center"}>
                                <CustomCheckBox  className={"p-0"} disableColor={"transparent"} checked={item.No} onChange={() => HandleCertificateVerificationChange(!item.No, i, "No")} />
                                <p className="poppinsRegular Text-Prime-Black text-center"> No </p>
                              </Grid> :
                              (item.Yes ? <p className="poppinsRegular Text-Prime-Green text-center">Yes</p> : <p className="poppinsRegular Text-Prime-Red text-center"> No </p>)
                            }
                          </StyledTableCell>
                        </StyledTableRow> 
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Qualification Level</StyledTableCell>
                        <StyledTableCell>Certificate Number</StyledTableCell>
                        <StyledTableCell align="center">Certificate</StyledTableCell>
                        <StyledTableCell align="center">Status</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>

                    <TableBody>
                      {QualificationCertificates?.map((row, i) => (
                        <StyledTableRow key={i}>
                          <StyledTableCell align="left">
                            <p className="poppinsRegular Text-Prime-Black">{row?.selectQualification}</p>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <p className="poppinsRegular Text-Prime-Black">{row?.certificateNumber}</p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <p className={"TextUnderGreen pointer poppinsRegular"} role="presentation" onClick={() => OpenCerticateImage(row, i)}>
                              View File
                            </p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {isEdit ?
                              <Grid item container flexDirection={"column"} alignItems={"center"}>
                                <Grid item container justifyContent={"center"} alignItems={"center"} flexDirection={"row"}>
                                  <CustomCheckBox
                                    className={"p-0"}
                                    disableColor={"transparent"}
                                    checked={row?.verified}
                                    onChange={() => HandleCertificateChange(!row?.verified, i, "verified")}
                                  />
                                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                                    Verified
                                  </p>
                                </Grid>
                                <Grid item container justifyContent={"center"} alignItems={"center"} flexDirection={"row"}>
                                  <CustomCheckBox
                                    className={"p-0"}
                                    disableColor={"transparent"}
                                    checked={row?.unVerified}
                                    onChange={() => HandleCertificateChange(!row.unVerified, i, "unVerified")}
                                  />
                                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                                    Not Okay
                                  </p>
                                </Grid>
                              </Grid> :
                              (row.verified==true ? <p className="poppinsRegular Text-Prime-Green text-center ">
                                Verified
                              </p> : <p className="poppinsRegular Text-Prime-Red text-center ">
                                Not Okay
                              </p>)
                            }
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Divider className="mt-1 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"} className="pt-3">
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  If Any Attachments
                </h5>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" >
                <TableContainer >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Certificate / Report Name</StyledTableCell>
                        <StyledTableCell>Attachment</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {isEdit ? attachmentList.map((row, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <CustomInput
                                placeholder={"Enter Certificate / Report Name"}
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                maxLength={50}
                                height={"45px"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid #666666"}
                                fontFamily={"PoppinsMedium"}
                                value={row.attachmentName}
                                onChange={(e) => HandleAttachmentValueChange(e.target.value, i, "text")}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <FileUploadButton
                                text={row.fileName}
                                className="px-3 py-2 ml-3 w-100"
                                placeholder={"Click Here to Upload File"}
                                multiple={false}
                                endIcon={true}
                                accept="image/jpeg,image/png,application/pdf"
                                onClick={(e) => HandleAttachmentValueChange(e, i, "file")}
                              />

                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      }) : attachmentNewList.map((row, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <p className="poppinsMedium Text-Prime-Black text-left w-100">
                                {row.attachmentName}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <p className={"TextUnderGreen pointer poppinsRegular"} role="presentation" onClick={() => OpenCerticateImage1({ ...row, level: row.attachmentName })}>
                                View File
                              </p>

                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              {attachmentList?.length < 5 && isEdit &&
                <Grid item lg={12} sm={12} md={12} xs={12} container justifyContent={"flex-end"}>
                  <GreenColorButton
                    type="submit"
                    className="px-3 py-2 ml-3"
                    disabled={attachmentLoader}
                    onClick={() => HandleNewAttachment()}
                    startIcon={<MdAddBox color={"#fff"} size={24} />}
                  >
                    Add New
                  </GreenColorButton>
                </Grid>}
              <Divider className="mt-2 mb-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} display={"flex"} alignItems={"center"} flexDirection={"row"} className="py-2">
                <Grid item lg={6} sm={6} md={6} xs={6} container alignItems={"center"} flexDirection={"row"}>
                  <CustomCheckBox
                    className={"p-0"}
                    disableColor={"transparent"}
                    checked={roleCheckBoxData?.candidateFit || !isEdit}
                    onChange={() => isEdit && HandleChandidateChange(!roleCheckBoxData.candidateFit, "candidateFit")}
                  />
                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                    Mark as Candidate as Fit for this Role
                  </p>
                </Grid>
                {isEdit && <Grid item lg={6} sm={6} md={6} xs={6} container alignItems={"center"} flexDirection={"row"}>
                  <CustomCheckBox
                    className={"p-0"}
                    disableColor={"transparent"}
                    checked={roleCheckBoxData?.candidateNotFit}
                    onChange={() => HandleChandidateChange(!roleCheckBoxData.candidateNotFit, "candidateNotFit")}
                  />
                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                    Mark as Candidate as not Fit for this Role
                  </p>
                </Grid>}
              </Grid>
              {(roleCheckBoxData.candidateNotFit || !isEdit) &&
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                  <Grid item container >
                    <p className="poppinsMedium Text-Prime-Black text-left w-100">
                      Reason for Rejection
                    </p>
                  </Grid>
                  <Grid item className="py-2 w-50">
                    {isEdit ? <CustomDropDown
                      placeholder={"Please Select Reason"}
                      borderRadius={"8px"}
                      data={RejectionsInfo}
                      selected={
                        rejectReason && {
                          label: rejectReason,
                          value: rejectReason,
                        }
                      }
                      onChange={(option) => { setRejectReason(option?.value); }}
                    /> :
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Education Qualification Not Met
                      </p>
                    }
                  </Grid>
                </Grid>
              }
              <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                <Grid item container >
                  <p className="poppinsMedium Text-Prime-Black text-left w-100">
                    Remarks
                  </p>
                </Grid>
                <Grid item className="py-2" container>
                  {isEdit ?
                    <TextAreaField
                      placeholder="Enter the Remarks If Any"
                      fontSize={14}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={1000}
                      padding={"2.5% 3% 2.5% 0%"}
                      placeholderColor="#666666"
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    /> :
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      this is admin remarks
                    </p>
                  }
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container alignItems={"flex-start"} justifyContent={"space-between"}>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined by
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {Examinedby}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined on
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(Examinedon)}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container >
                  <Grid item lg={6} sm={6} md={6} xs={6} container className="py-2" flexDirection={"column"}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Examined Place
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                      {ExaminedPlace? ExaminedPlace:"---" }
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
        modalFooter={
          < Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"} >
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-3 py-2"
              onClick={() => CloseVerfiyCertificateModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
            {
              isEdit &&
              <GreenColorButton
                type="submit"
                className="px-3 py-2 ml-3"
                onClick={() => UpdateModalVerifyCerticate()}
              >
                Update
                {Loading && (
                  <CircularProgress size="1rem" style={{ color: "#fff" }} />
                )}
              </GreenColorButton>
            }
          </Grid >
        }
      />
      < CustomModal
        open={confomationModal}
        setOpen={CloseConfomationModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={< Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">Are you sure you want to update this candidate’s certificate verification ?</p>
          <p className="poppinsLight Text-Prime-Gray pt-3 text-center">Ensure all details are accurate before update.</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => CloseConfomationModal()}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              disabled={Loading}
              onClick={() => UpdatePhysicalData()}
            >
              Yes
              {Loading && (
                <CircularProgress size="1rem" style={{ color: "#fff" }} />
              )}
            </DarkGreenColorButton>
          </Grid>
        </Grid >
        }
      />
      < CerificateModal
        certificateImageModal={certificateImageModal}
        setCertificateImageModal={setCertificateImageModal}
        CloseCerticateImage={CloseCerticateImage}
        imageUrl={imageUrl}
        fileExtentions={fileExtentions}
        certificateName={certificateName}
        isEdit={isEdit}
        selectedIndex={selectedIndex}
        UpdateCerficate={UpdateCerficate}
        certificateSelectList={certificateSelectList}
        setCertificateSelectList={setCertificateSelectList}
      />
    </Grid >


  );
};

export default VerifyCertificateDetailsModal;
